// extracted by mini-css-extract-plugin
module.exports = {"dropdownPreset":"DropdownPreset__dropdownPreset__r19E9"};